export var ProfileType;
(function (ProfileType) {
    ProfileType["CUSTOMER"] = "CUSTOMER";
    ProfileType["GDS"] = "GDS";
    ProfileType["CORPORATION"] = "CORPORATION";
    ProfileType["TRAVEL_AGENT"] = "TRAVEL_AGENT";
    ProfileType["WHOLESALER"] = "WHOLESALER";
    ProfileType["GROUP"] = "GROUP";
    ProfileType["TOUR_OPERATOR"] = "TOUR_OPERATOR";
    ProfileType["CRO"] = "CRO";
    ProfileType["REP_COMPANY"] = "REP_COMPANY";
    ProfileType["INTERNET_BROKER"] = "INTERNET_BROKER";
    ProfileType["AIRLINE"] = "AIRLINE";
    ProfileType["HOTEL"] = "HOTEL";
    ProfileType["CAR_RENTAL"] = "CAR_RENTAL";
    ProfileType["CRUISE_LINE"] = "CRUISE_LINE";
    ProfileType["EMPLOYEE"] = "EMPLOYEE";
    ProfileType["EVENT_HOST"] = "EVENT_HOST";
    ProfileType["SUPPLIER_PARTNER"] = "SUPPLIER_PARTNER";
    ProfileType["BILLING_CONTACT"] = "BILLING_CONTACT";
    ProfileType["AUTHORIZED_SIGNATURE"] = "AUTHORIZED_SIGNATURE";
    ProfileType["GENERAL_SERVICE_CONTRACTOR"] = "GENERAL_SERVICE_CONTRACTOR";
    ProfileType["ARRANGER"] = "ARRANGER";
    ProfileType["ASSOCIATION"] = "ASSOCIATION";
    ProfileType["TRAVEL_AGENCY"] = "TRAVEL_AGENCY";
    ProfileType["NEWSLETTER_SUBSCRIBER"] = "NEWSLETTER_SUBSCRIBER";
    /** Someone who isn't a guest, created when staff invite an email address to a survey. */
    ProfileType["OTHER"] = "OTHER";
})(ProfileType || (ProfileType = {}));
